import { useTranslator } from '@gandi/translate';
import { CategoryBadge } from './CategoryBadge';
import { getTheme } from './helpers';
import { jsx as _jsx } from "react/jsx-runtime";
function useLabel(kind) {
  const {
    __
  } = useTranslator();
  switch (kind) {
    case 'DomainCreate':
      return __('Domain Registration');
    case 'services':
    case 'CorporateCreate':
      return __('Services');
    case 'DomainRenew':
      return __('Domain Renewal');
    case 'DomainRestore':
      return __('Domain Restore');
    case 'DomainTransfer':
      return __('Domain Transfer');
    case 'DomainChangeOwner':
      return __('Domain Owner Change');
    case 'CertificateCreate':
      return __('SSL Certificate Creation');
    case 'CloudAdd':
      return __('Cloud Resources');
    case 'PaasCreate':
      return __('Hosting Creation');
    case 'PaasRenew':
      return __('Hosting Renewal');
    case 'PaasUpdate':
      return __('Hosting Update');
    case 'MailboxCreate':
    case 'MailboxStandAloneCreate':
    case 'Mailboxv2Create':
      return __('Mailbox Creation');
    case 'MailboxUpdate':
    case 'Mailboxv2Update':
      return __('Mailbox Update');
    case 'MailboxRenew':
    case 'Mailboxv2Renew':
      return __('Mailbox Renew');
    case 'MailboxConvert':
    case 'Mailboxv2Convert':
      return __('Mailbox Conversion');
    case 'MarketplaceCreate':
      return __('Marketplace Service Creation');
    case 'MarketplaceRenew':
      return __('Marketplace Service Renewal');
    case 'MarketplaceUpdate':
      return __('Marketplace Service Update');
    case 'MarketplaceDelete':
      return __('Marketplace Service Deletion');
    case 'PremiumDNSCreate':
      return __('Domain Options');
    default:
      return __('Other products');
  }
}
export function ProductKindBadge({
  kind,
  productType
}) {
  const title = useLabel(kind);
  return /*#__PURE__*/_jsx(CategoryBadge, {
    theme: getTheme(productType),
    children: title
  });
}